import axios from 'axios';

const instance = axios.create({
  withCredentials: false
});

// Interceptor para toggle dev: cambia /api → /api-local (proxy) sin CORS
// Auto-detecta localhost: si la URL es localhost, usa /api-local por defecto.
// Se puede forzar a 'prod' con localStorage.setItem('dev_api_mode', 'prod')
instance.interceptors.request.use(config => {
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const defaultMode = isLocalhost ? 'local' : 'prod';
  const mode = localStorage.getItem('dev_api_mode') || defaultMode;
  if (mode === 'local' && config.url?.startsWith('/api') && !config.url.startsWith('/api-local')) {
    config.url = config.url.replace('/api', '/api-local');
  }
  return config;
});

export default instance;
